import React, { useEffect, useState } from "react";
import product_detail_image from "../../assets/image/png/productDetail_imag.png";
import { Link, useNavigate, useParams } from "react-router-dom";
import { getDroneSoftwareDetails } from "../../services/DroneServices";
import HTMLReactParser from "html-react-parser";
import axios from "axios";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import DronePartInquire from "../common/DronePartEnquiry";
import {
  handleChangeCartCount,
  handleLoginPopup,
} from "../../redux/slice/userSlice";
import arrowback from "../../assets/image/png/arrow_back.png";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import ReactImageMagnify from "react-image-magnify";
import madeinindia from "../../assets/image/png/Madeinindia2.png"


const DroneSoftwareDetails = () => {
  const token = Cookies.get("token");
  const [model, setModel] = useState(false);
  const [selectedImage, setSelectedImage] = useState(product_detail_image);
  const [quantity, setQuanity] = useState();
  const dispatch = useDispatch();
  const { id } = useParams();
  const navigate = useNavigate();
  const [droneDetails, setDroneDetails] = useState("");

  const handleThumbnailClick = (thumbnail) => {
    setSelectedImage(thumbnail);
  };

  useEffect(() => {
    if (id) {
      window.scrollTo(0, 0);
      getDroneSoftwareDetails(id).then((res) => {
        if (res.status == "success") {
          setDroneDetails(res.data);
          setQuanity(res?.data.quantity);
          setSelectedImage(res.data.images[0]);
        }
      });
    }
  }, [id]);

  const handleCart = async () => {
    if (!token) {
      dispatch(handleLoginPopup(true));
      return;
    }

    let payload = {};

    if (droneDetails?.isDrone) {
      payload.droneId = id;
      payload.droneIdd = "";
    } else {
      payload.droneId = "000000000000000000000000"; // dummy valid ObjectId
      payload.droneIdd = id; // real part id
    }
    const response = await axios.post(
      process.env.REACT_APP_API_URL + "/addToCart",
      payload,
      {
        headers: { token: Cookies.get("token") },
      }
    );
    if (response?.data?.status === "success") {
      setDroneDetails({ ...droneDetails, isCartItem: true });
      toast.success(response?.data?.message);
      dispatch(handleChangeCartCount(1));
    } else {
      toast.error(response?.data?.message);
    }
  };

  const handleUpdateQuantity = async (id, quantity) => {
    const response = await axios.post(
      process.env.REACT_APP_API_URL + "/updateDroneSoftwareQuantity",
      { droneId: id, quantity,droneIdd:id },
      {
        headers: {
          token: Cookies.get("token"),
        },
      }
    );
    if (response?.data?.status == "success") {
      toast.success("Quantity Updated Successfully");
      setDroneDetails({ ...droneDetails, quantity: quantity });
    }
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  };

  return (
    <div className="bg-white">
      <div className="bg-white mt-5">
        <div className="container">
          {droneDetails?.madeInIndia && (
  <div
    className="position-absolute top-0 end-0 me-4 mt-4 bg-success text-white px-3 py-2 rounded-start shadow"
    style={{ zIndex: 10 }}
  >
    <strong>🇮🇳 Made in India</strong>
  </div>
)}

          <p className="mb-0 bg-white fw-normal ff_inter fs_21">
            <span className="color_blue">
              <Link to="/intellegence-market-solutions"> All Drone Softwares </Link>
            </span>
            / {droneDetails?.title}
          </p>
        </div>
      </div>

      {/* Updated back button with link */}
                {/* <div
            className="d-flex align-items-center gap-1 cursor_pointer ms-4"  // Added ms-2 for left margin
            onClick={() => navigate("/drone-parts")}
          >
            <img
              style={{ width: "18px", height: "18px" }}  // Fixed typo in height
              src={arrowback}
              alt="backarrow"
            />
            <p className="mb-0 color_blue_2 fw-medium">Back to page</p>
          </div> */}


          <div className="pt-3 bg-white">
            <div className="container">
              <div className="row mt-xl-5 mt-4">
                {/* Thumbnails for Web View */}
                <div className="col-1 d-xl-block d-none">
                  {droneDetails?.images?.map((item, index) => (
                    <img
                      key={index}
                      height={72}
                      className="w-100 rounded-2 mb-2 object-fit-cover cursor_pointer"
                      src={item}
                      alt="product_demoimage"
                      onClick={() => handleThumbnailClick(item)}
                    />
                  ))}
                </div>

                {/* Main Image for Web and Carousel for Mobile */}
                <div className="col-xl-5 col-lg-6" style={{ maxWidth: "500px" }}>
                  {/* Web View */}
                  <div className="d-none d-xl-block" style={{ position: "relative" }}> 
                    {droneDetails?.madeInIndia && (
                        <img
                          src={madeinindia}
                          alt="Made in India"
                          style={{
                            position: "absolute",
                            // top: "10px",
                            left: "10px",
                            height: "50px",
                            zIndex: 2,
                          }}
                        />
                      )}
                    <ReactImageMagnify
                      {...{
                        smallImage: {
                          alt: "product_detail_image",
                          isFluidWidth: true,
                          src: selectedImage,
                        },
                        largeImage: {
                          src: selectedImage,
                          width: 1000,
                          height: 1000,
                        },
                        enlargedImageContainerDimensions: {
                          width: "130%",
                          height: "145%",
                        },
                        enlargedImagePosition: "over",
                        shouldUsePositiveSpaceLens: true, // Ensures a smooth zoom effect
                      }}
                    />
                  </div>

                  {/* Mobile View */}
                  <div className="d-block d-xl-none" style={{ position: "relative" }}>
                    {droneDetails?.madeInIndia && (
                  <img
                    src={madeinindia}
                    alt="Made in India"
                    style={{
                      position: "absolute",
                      // top: "10px",
                      // left: "10px",
                      height: "50px",
                      zIndex: 2,
                    }}
                  />
                )}  
                    {droneDetails?.images?.length > 1 ? (
                      <Slider {...settings}>
                        {droneDetails?.images?.map((item, index) => (
                          <div key={index}>
                            <img
                              className="w-100 object-fit-contain rounded-3"
                              src={item}
                              alt="product_detail_image"
                            />
                          </div>
                        ))}
                      </Slider>
                    ) : (
                      <img
                        className="w-100 object-fit-contain rounded-3"
                        src={selectedImage}
                        alt="product_detail_image"
                      />
                    )}
                  </div>
                </div>

                {/* Product Details */}
                <div className="col-lg-6 mt-5 mt-lg-0 d-flex flex-column">
                  {/* Title */}
                  <h3 className="fs_43 fw-bold ff_inter color_darkgray mb-3 text-start">
                    {droneDetails?.title}
                  </h3>

                  {/* Description Box */}
                  <div className=" rounded p-3 bg-light">
                    <p className="mb-0 fs_17 ff_inter color_darkgray text-start">
                      {droneDetails?.description}
                    </p>
                  </div>

                  {/* Price & Quantity Section */}
                  <div className="d-flex gap-4 mt-4 align-items-center">
                    {/* Price */}
                 <div className="fs_17 fw-bold ff_inter color_darkgray">
                    Rs. {droneDetails?.price?.toLocaleString('en-IN')}
                  </div>


                    {/* Quantity Selector */}
                    {/* <div className=" align-items-center border rounded px-3 py-0">
                      <button
                        onClick={() => quantity > 1 && setQuanity(quantity - 1)}
                        className="fs_26 ff_inter bg-transparent border-0 px-2"
                      >
                        -
                      </button>
                      <span className="mx-3 fs_18 ff_inter">{quantity}</span>
                      <button
                        onClick={() => quantity < 10 && setQuanity(quantity + 1)}
                        className="fs_26 ff_inter bg-transparent border-0 px-2"
                      >
                        +
                      </button>
                    </div> */}
                      {/* Buttons (View Cart / Add to Cart) */}
                  {/* <div className="">
                    {droneDetails?.isCartItem && droneDetails.quantity === quantity ? (
                      <button
                        className="viewall_btn px-4 py-2 fs_17 fw-medium ff_inter text-white"
                        onClick={() => navigate("/cart")}
                      >
                        View Cart
                      </button>
                    ) : token && droneDetails?.isCartItem ? (
                      <button
                        className="viewall_btn px-4 py-2 fs_17 fw-medium ff_inter text-white"
                        onClick={() => handleUpdateQuantity(droneDetails._id, quantity)}
                      >
                        Update Quantity
                      </button>
                    ) : (
                      <button
                        className="viewall_btn px-4 py-2 fs_17 fw-medium ff_inter text-white"
                        onClick={() => handleCart()}
                      >
                        Add to Cart
                      </button>
                    )}
                  </div> */}
                  <button
                    className="viewall_btn px-4 py-2 fs_17 fw-medium ff_inter text-white"
                    onClick={() => setModel(true)}
                  >
                    Enquire Now
                  </button>
                  <DronePartInquire setModel={setModel} model={model} />
                  </div>

                
                </div>

          </div>
        </div>
      </div>
      <div className="">
        <div className="container">
          <div className="bg_lightblue mt-5 p-md-5 p-4 rounded-5 shadow-lg">
            <h4 className="fs_26 fw-bold ff_inter color_blue mb-4 text-center">
              Specifications
            </h4>

            <div className="mt-4">
              {droneDetails?.specifications ? (
                <div className="bg-white p-4 rounded-4 shadow-sm">
                  <div className="d-flex flex-column space-y-4">
                    {/* Rendered Specifications */}
                    {HTMLReactParser(droneDetails.specifications)}
                  </div>
                </div>
              ) : (
                <p className="text-center text-gray-600">No specifications available.</p>
              )}
            </div>
          </div>
        </div>
      </div>

    </div>
  );
};

export default DroneSoftwareDetails;
